import { h } from '..//index.js';
import { setFetchStartState, setPartialFetchStartState } from '../fetchLoadable.js';
import { createNotLoaded } from '../Loadable/utils.js';
import * as actionTypes from './actionTypes.js';
export const importsReducer = (state = createNotLoaded(), action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_ALL_IMPORTS_START:
        case actionTypes.FETCH_IMPORTS_START:
            return { ...setPartialFetchStartState(state, payload.res, 'imports') };
        case actionTypes.FETCH_IMPORTS_SUCCESS:
            return {
                ...state,
                loadingState: payload.res.loadingState,
                data: {
                    reachedLimit: payload.res.data.length < payload.quantity,
                    from: payload.from + payload.quantity,
                    imports: payload.reset
                        ? payload.res.data
                        : // @ts-ignore
                            [...state.data.imports, ...payload.res.data],
                },
            };
        case actionTypes.FETCH_ALL_IMPORTS_SUCCESS:
            return {
                ...state,
                loadingState: payload.res.loadingState,
                data: {
                    reachedLimit: true,
                    from: payload.res.data.length,
                    imports: payload.res.data,
                },
            };
        case actionTypes.FETCH_IMPORTS_ERROR:
        case actionTypes.FETCH_ALL_IMPORTS_ERROR: {
            return { ...payload.res };
        }
        case actionTypes.CLEAR_IMPORTS: {
            if (h.isLoaded(state)) {
                return {
                    ...state,
                    data: {
                        reachedLimit: false,
                        from: 0,
                        imports: [],
                    },
                };
            }
            return state;
        }
        case actionTypes.DELETE_IMPORT: {
            if (h.isLoaded(state)) {
                return {
                    ...state,
                    data: {
                        ...state.data,
                        imports: state.data.imports.filter((im) => im.importId !== payload.importId),
                    },
                };
            }
            return state;
        }
        default:
            return state;
    }
};
export const appendicesReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_AMOUNT_APPENDICES_START: {
            return {
                ...state,
                [payload.importId]: setFetchStartState(state[payload.importId], payload.res),
            };
        }
        case actionTypes.FETCH_AMOUNT_APPENDICES_SUCCESS:
        case actionTypes.FETCH_AMOUNT_APPENDICES_ERROR: {
            return {
                ...state,
                [payload.importId]: {
                    ...state[payload.importId],
                    data: payload.res.data.count,
                    loadingState: payload.res.loadingState,
                },
            };
        }
        default:
            return state;
    }
};
export const importReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_IMPORT_START: {
            return {
                ...state,
                [payload.importId]: setFetchStartState(state[payload.importId], payload.res),
            };
        }
        case actionTypes.FETCH_IMPORT_SUCCESS:
        case actionTypes.FETCH_IMPORT_ERROR: {
            return { ...state, [payload.importId]: payload.res };
        }
        case actionTypes.SET_STATUS_UPDATE: {
            if (h.isLoaded(state[payload.importId])) {
                return {
                    ...state,
                    [payload.importId]: {
                        ...state[payload.importId],
                        data: {
                            // @ts-ignore
                            ...state[payload.importId].data,
                            status: {
                                // @ts-ignore
                                ...state[payload.importId].data.status,
                                ...payload.status,
                            },
                        },
                    },
                };
            }
            return state;
        }
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map